import { ChangeEventHandler, FC } from 'react';

import clsx from 'clsx';
import useSWR from 'swr';

import { AddPromoCodeMenu } from './addPromoCodeMenu/AddPromoCodeMenu';
import { ExportPromoCodesButton } from './exportPromoCodesButton/ExportPromoCodesButton';
import { PromoCodeTable } from './promoCodeTable/PromoCodeTable';

import css from './PromoCodePage.module.css';

import { promoCodeService } from 'v2/api/promoCodeService';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { SearchTextField } from 'v2/components/searchTextField/SearchTextField';
import { useFilter } from 'v2/hooks/useFilter';
import { usePagination } from 'v2/hooks/usePagination';
import { PromoCodeFilter } from 'v2/types/PromoCodeModel';

export const PromoCodePage: FC = () => {
  const { filter, debouncedFilter, onChange } = useFilter<PromoCodeFilter>({
    groupName: '',
    name: '',
    createdBy: '',
  });

  const pagination = usePagination();

  const { data, mutate } = useSWR(
    ['getPromoCodes', pagination.page, pagination.pageSize, debouncedFilter],
    promoCodeService.getPromoCodes,
    { keepPreviousData: true }
  );

  const handleChangeFilter =
    (field: keyof PromoCodeFilter): ChangeEventHandler<HTMLInputElement> =>
    (e) => {
      onChange(field, e.target.value);
    };

  return (
    <PageLayout className={css.promoCodePage} overflow="hidden">
      <div className={css.promoCodePageHeader}>
        <PageTitle>Promo Code Settings</PageTitle>

        <div className={clsx('form-group', css.promoCodePageAction)}>
          <AddPromoCodeMenu onRevalidate={mutate} />

          <ExportPromoCodesButton />
        </div>
      </div>

      <div className={css.promoCodePageContent}>
        <div className="form-group">
          <SearchTextField value={filter.groupName} onChange={handleChangeFilter('groupName')} label="Group Name" />

          <SearchTextField value={filter.name} onChange={handleChangeFilter('name')} label="Promo Code Name" />

          <SearchTextField value={filter.createdBy} onChange={handleChangeFilter('createdBy')} label="Created By" />
        </div>

        <PromoCodeTable data={data} pagination={pagination} onRevalidate={mutate} />
      </div>
    </PageLayout>
  );
};
